import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import * as styles from "../styles/cookie-banner.module.css"

const GA_ID = "G-YBTJ2V3044"
const CONSENT_KEY = "cookie-consent" // chiave localStorage

/**
 * Inietta lo script Google Analytics dinamicamente nel DOM.
 * Chiamato SOLO dopo il consenso esplicito dell'utente.
 */
function loadGoogleAnalytics() {
  if (typeof window === "undefined") return
  // Evita doppio caricamento
  if (document.getElementById("ga-script")) return

  // Abilita GA (era disabilitato di default)
  window[`ga-disable-${GA_ID}`] = false

  // Inizializza dataLayer
  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag = gtag
  gtag("js", new Date())
  gtag("config", GA_ID, {
    anonymize_ip: true,        // GDPR: anonimizza IP
    send_page_view: true,
  })

  // Carica lo script gtag.js
  const script = document.createElement("script")
  script.id = "ga-script"
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
  document.head.appendChild(script)
}

/**
 * Disabilita GA e impedisce qualsiasi invio di dati.
 */
function disableGoogleAnalytics() {
  if (typeof window === "undefined") return
  window[`ga-disable-${GA_ID}`] = true
}

const CookieBanner = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (typeof window === "undefined") return

    // GA disabilitato di default finché non c'è consenso
    window[`ga-disable-${GA_ID}`] = true

    const consent = localStorage.getItem(CONSENT_KEY)

    if (consent === "accepted") {
      // Consenso già dato: carica GA silenziosamente
      loadGoogleAnalytics()
    } else if (consent === "rejected") {
      // Già rifiutato: mantieni GA disabilitato
      disableGoogleAnalytics()
    } else {
      // Nessuna scelta: mostra il banner
      setVisible(true)
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted")
    loadGoogleAnalytics()
    setVisible(false)
  }

  const handleReject = () => {
    localStorage.setItem(CONSENT_KEY, "rejected")
    disableGoogleAnalytics()
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div
      className={styles.banner}
      role="dialog"
      aria-live="polite"
      aria-label="Banner consenso cookie"
    >
      <div className={styles.inner}>
        <p className={styles.text}>
          Questo sito utilizza cookie analitici per migliorare l'esperienza.{" "}
          <Link to="/privacy/">Consulta la Privacy Policy.</Link>
        </p>
        <div className={styles.buttons}>
          <button
            className={styles.btnReject}
            onClick={handleReject}
            aria-label="Rifiuta i cookie analitici"
          >
            Rifiuta
          </button>
          <button
            className={styles.btnAccept}
            onClick={handleAccept}
            aria-label="Accetta i cookie analitici"
          >
            Accetta
          </button>
        </div>
      </div>
    </div>
  )
}

export { loadGoogleAnalytics, disableGoogleAnalytics, GA_ID, CONSENT_KEY }
export default CookieBanner
